import { DocumentsAPI } from "@/lib/api"
import {
  SET_DOCUMENTS_SELECTED,
  SET_DOCUMENTS_AVAILABLE,
  ASSIGN_DOCUMENTS
} from "@/store/mutationTypes"
import { UsersAPI } from "../../lib/api"

const state = {
  available: [],
  selected: []
}

// getters
const getters = {
  getAvailable: state => state.available,
  getSelected: state => state.selected.filter(el => el.selected)
}

// actions
const actions = {
  async loadDocuments({ dispatch, commit }, { userId }) {
    DocumentsAPI.list()
      .then(response => {
        commit(SET_DOCUMENTS_AVAILABLE, response)
      })
      .then(() => {
        DocumentsAPI.getDocumentsByUserId(userId).then(response => {
          // add selected property so that the getter can need a filter
          // so that it does not update as soon as the dragable event
          // puts the element in the selected column
          let s = response.map(el => {
            el.selected = true
            return el
          })
          commit(SET_DOCUMENTS_SELECTED, response)
        })
      })
  },
  async assignDocuments({ commit, dispatch }, { userId, documentIds }) {
    commit(
      ASSIGN_DOCUMENTS,
      await UsersAPI.assignDocuments(userId, documentIds)
    )
    await dispatch("loadDocuments", { userId: userId })
  }
}

// mutations
const mutations = {
  [SET_DOCUMENTS_AVAILABLE](state, documents) {
    state.available = documents
  },
  [SET_DOCUMENTS_SELECTED](state, documents) {
    state.selected = documents
  },
  [ASSIGN_DOCUMENTS](state, documentId) {},
  reset(state) {
    state.available.splice(0, state.available.length)
    state.selected.splice(0, state.selected.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
